<section class="alerts-page">
  <div class="heading">
    <div>
      <h1>Alertas de termos</h1>
      <p>Avise sobre o vencimento do termo de recebimento de amostras.</p>
    </div>
    @if (data) {
      <span class="dev-badge">{{ data.ambiente === 'prod' ? 'PRODUÇÃO' : 'SOMENTE DEV' }}</span>
    }
  </div>
  @if (error) {
    <div role="alert" class="notice error">
      {{ error }} <button mat-button (click)="load()" [disabled]="busy">Tentar novamente</button>
    </div>
  }
  @if (data) {
    <div class="notice">
      {{
        data.ambiente === 'prod'
          ? 'Os envios abrangem os participantes elegíveis com termo a vencer.'
          : 'Os envios estão restritos às contas de teste: ' +
            data.destinatarios_dev.join(', ') +
            '.'
      }}
      @if (data.ambiente !== 'prod') {
        Nenhum destinatário de produção receberá estes alertas.
      }
    </div>
    <section class="card">
      <h2>Agendamento automático</h2>
      <p [class.error]="data.enabled && !data.worker_ativo">
        {{
          data.worker_ativo
            ? 'Processo automático em execução.'
            : 'Sem sinal recente do processo automático. Verifique antes de contar com os envios agendados.'
        }}
      </p>
      <p class="status">{{ data.enabled ? 'Ativo' : 'Pausado' }}</p>
      <p>
        O sistema envia um aviso por faixa e por termo: entre 90 e 31 dias, entre 30 e 1 dia e no
        dia do vencimento. Se uma faixa já passou, envia somente o aviso da faixa atual. O texto
        mostra os dias restantes reais.
      </p>
      <form (ngSubmit)="save()">
        <mat-checkbox name="enabled" [(ngModel)]="form.enabled" [disabled]="busy"
          >Ativar agendador</mat-checkbox
        >
        <p>
          Checagem diária às <strong>10h de Brasília</strong>. Fora desse horário, o sistema
          processa somente novas tentativas de avisos com falha temporária, respeitando o atraso de
          cada tentativa. Avisos já enviados não são repetidos.
        </p>
        <div class="actions">
          <button mat-flat-button type="submit" [disabled]="busy">Salvar configuração</button
          ><button mat-stroked-button type="button" (click)="simulate()" [disabled]="busy">
            Simular sem enviar</button
          ><button
            mat-stroked-button
            type="button"
            (click)="execute()"
            [disabled]="busy || !data.enabled"
          >
            Enviar alertas devidos agora</button
          ><button mat-button type="button" (click)="load()" [disabled]="busy">Atualizar</button>
        </div>
      </form>
      <p class="muted">
        Última checagem diária:
        {{
          data.ultima_checagem_diaria_em
            ? (data.ultima_checagem_diaria_em | date: 'dd/MM/yyyy HH:mm' : '-0300')
            : 'Aguardando primeira execução'
        }}
        (Brasília).
      </p>
      @if (data.ultimo_erro) {
        <p role="alert" class="error">
          A última execução apresentou uma falha. Verifique os registros antes de reenviar.
        </p>
      }
      @if (busy) {
        <p role="status">Processando…</p>
      }
    </section>
  }
  @if (result) {
    <section class="card" aria-live="polite">
      <h2>
        {{
          previewResult
            ? 'Resultado da simulação — nenhum envio realizado'
            : 'Resultado da execução'
        }}
      </h2>
      <p>{{ reason(result.reason) }}</p>
      <div class="metrics">
        <p>
          <strong>{{ result.checked }}</strong> cadastros verificados
        </p>
        <p>
          <strong>{{ result.due }}</strong> avisos devidos
        </p>
        <p>
          <strong>{{ result.sent }}</strong> enviados
        </p>
        <p>
          <strong>{{ result.retry }}</strong> novas tentativas
        </p>
        <p>
          <strong>{{ result.failed + result.review }}</strong> precisam de revisão
        </p>
        <p>
          <strong>{{ result.suspended }}</strong> recorrências
          {{ previewResult ? 'a suspender' : 'suspensas' }}
        </p>
      </div>
    </section>
  }
  @if (data) {
    @if (data.pending.length) {
      <section class="card">
        <h2>Envios que precisam de revisão</h2>
        <p>
          Uma falha de conexão pode ocorrer depois da aceitação do e-mail. Esses avisos não são
          reenviados automaticamente. Confira o resultado no provedor antes de decidir.
        </p>
        @for (row of data.pending; track key(row)) {
          <div class="pending">
            <p>
              <strong>Termo {{ row.id_consentimento }} · {{ row.faixa }}</strong> —
              {{ status(row.status) }}
            </p>
            <mat-checkbox [(ngModel)]="verified[key(row)]" [disabled]="busy"
              >Conferi o resultado deste envio no provedor</mat-checkbox
            >
            <div class="actions">
              <button
                mat-stroked-button
                [disabled]="busy || !verified[key(row)]"
                (click)="resolve(row, true)"
              >
                Confirmar que foi enviado</button
              ><button
                mat-stroked-button
                [disabled]="busy || !verified[key(row)]"
                (click)="resolve(row, false)"
              >
                Confirmar que não foi enviado
              </button>
            </div>
          </div>
        }
      </section>
    }
    <section class="card">
      <h2>Histórico recente</h2>
      <p>Configurações e tentativas de envio ficam registradas para acompanhamento.</p>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Data (Brasília)</th>
              <th>Ação</th>
              <th>Resultado</th>
            </tr>
          </thead>
          <tbody>
            @for (row of data.history; track row.id) {
              <tr>
                <td>{{ row.criacao | date: 'dd/MM/yyyy HH:mm' : '-0300' }}</td>
                <td>{{ row.assunto }}</td>
                <td>{{ historyDetail(row) }}</td>
              </tr>
            } @empty {
              <tr>
                <td colspan="3">Nenhuma execução registrada.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
    <section class="card">
      <h2>Conteúdo dos avisos</h2>
      <p>
        Os e-mails usam a data de validade do termo e direcionam para o perfil do participante no
        ambiente atual.
      </p>
      @for (model of data.modelos; track model.faixa) {
        <details>
          <summary>{{ model.faixa }} · {{ model.subject }}</summary>
          <p class="email-preview">{{ model.text }}</p>
        </details>
      }
    </section>
  }
</section>
